<template>
  <section v-loading.fullscreen.lock="loading" class="entry">
    <div class="entry-header">
      <com-tabs
        :list="statisticsInfo.obj.tabs1"
        class="entry-tabs"
        :default-tab="activeTab"
        @change="changeTab"
      >
        <template v-slot:text="{ obj }">
          <div
            :class="{ activeTab: activeTab == obj.key }"
            class="entry-tabs-item"
          >
            {{ obj.name }}
          </div>
        </template>
      </com-tabs>
      <span class="btn1" @click="handleSubmitAll">{{
        status == 0 ? "上报" : "返回编辑"
      }}</span>
      <!-- <span>
        <el-upload
          class="upload-demo"
          action="http://36.137.252.61:8004/api/uploadFile"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          :limit="1"
          :on-exceed="handleExceed"
          :file-list="fileList"

        >
          <el-button size="small" type="primary">导入</el-button>
        </el-upload>
      </span> -->
      <span id="download" class="btn2" @click="handleOut">导出</span>
    </div>

    <div v-if="status == 0 || status == 3" class="entry-content">
      <com-term0
        v-if="data1"
        v-show="activeTab == 0"
        :data="data11 ? data11 : data1"
        @pre="handlePrePage"
        @next="handleNextPage"
        @clear="handleClear(data11)"
      />
      <com-term1
        v-if="data2"
        v-show="activeTab == 1"
        :data="data12 ? data12 : data2"
        @pre="handlePrePage"
        @next="handleNextPage"
        @clear="handleClear(data12)"
      />
      <com-term2
        v-if="data3"
        v-show="activeTab == 2"
        :data="data13 ? data13 : data3"
        @pre="handlePrePage"
        @next="handleNextPage"
        @clear="handleClear(data13)"
      />
      <com-term3
        v-if="data4"
        v-show="activeTab == 3"
        :data="data14 ? data14 : data4"
        @pre="handlePrePage"
        @next="handleNextPage"
        @clear="handleClear(data14)"
      />
      <com-term4
        v-if="d5 ? d5 : data5"
        v-show="activeTab == 4"
        :data="data15 ? data15 : data5"
        @pre="handlePrePage"
        @next="handleNextPage"
        @clear="handleClear(data15)"
      />
      <com-term5
        v-if="data6"
        v-show="activeTab == 5"
        :data="data16 ? data16 : data6"
        @pre="handlePrePage"
        @next="handleNextPage"
        @clear="handleClear(data16)"
      />
      <com-term6
        v-if="data7"
        v-show="activeTab == 6"
        :data="data17 ? data17 : data7"
        @pre="handlePrePage"
        @next="handleNextPage"
        @clear="handleClear(data17)"
      />
    </div>
    <div v-else class="entry-content">
      <com-term10 v-if="d1" v-show="activeTab == 0" :data="d1" />
      <com-term11 v-if="d2" v-show="activeTab == 1" :data="d2" />
      <com-term12 v-if="d3" v-show="activeTab == 2" :data="d3" />
      <com-term13 v-if="d4" v-show="activeTab == 3" :data="d4" />
      <com-term14 v-if="d5" v-show="activeTab == 4" :data="d5" />
      <com-term15 v-if="d6" v-show="activeTab == 5" :data="d6" />
      <com-term16 v-if="d7" v-show="activeTab == 6" :data="d7" />
    </div>
  </section>
</template>
<script>
import api from '@/api/app'
import mock from '@/utils/mock'
import comTabs from '@/components/comTabs'
import comTerm0 from './details/comTerm0.vue'
import comTerm1 from './details/comTerm1.vue'
import comTerm2 from './details/comTerm2.vue'
import comTerm3 from './details/comTerm3.vue'
import comTerm4 from './details/comTerm4.vue'
import comTerm5 from './details/comTerm5.vue'
import comTerm6 from './details/comTerm6.vue'
import comTerm10 from '../comQuery/details/comTerm10.vue'
import comTerm11 from '../comQuery/details/comTerm11.vue'
import comTerm12 from '../comQuery/details/comTerm12.vue'
import comTerm13 from '../comQuery/details/comTerm13.vue'
import comTerm14 from '../comQuery/details/comTerm14.vue'
import comTerm15 from '../comQuery/details/comTerm15.vue'
import comTerm16 from '../comQuery/details/comTerm16.vue'
export default {
  name: 'ComEntry',
  components: {
    comTabs,
    comTerm0,
    comTerm1,
    comTerm2,
    comTerm3,
    comTerm4,
    comTerm5,
    comTerm6,
    comTerm10,
    comTerm11,
    comTerm12,
    comTerm13,
    comTerm14,
    comTerm15,
    comTerm16
  },
  props: {},
  data() {
    return {
      loading: true,
      activeTab: 0,
      statisticsInfo: mock.statistics.statistics.viewInfo,
      statisticsInit: mock.statistics.statistics.init,
      data1: null, // 表格模版
      data2: null,
      data3: null,
      data4: null,
      data5: null,
      data6: null,
      data7: null,
      data11: null, // 本地数据
      data12: null,
      data13: null,
      data14: null,
      data15: null,
      data16: null,
      data17: null,
      status: 0,
      form1: null, // 提交数据
      form2: null,
      form3: null,
      form4: null,
      form5: null,
      form6: null,
      form7: null,
      fileList: [],
      d7: null, // 已提交数据与模版合并
      d6: null,
      d5: null,
      d4: null,
      d3: null,
      d2: null,
      d1: null
    }
  },
  computed: {},
  watch: {},
  created() {
    api.statistics.status().then((res) => {
      this.status = res.data.status
      this.tableMode()
    })
  },
  mounted() {

  },
  methods: {

    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      )
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    handleSubmitAll() {
      // if (
      //   this.d1 &&
      //   this.d2 &&
      //   this.d3 &&
      //   this.d4 &&
      //   this.d5 &&
      //   this.d6 &&
      //   this.d7
      // ) {
      //   this.$message.success('已提交审核')
      // }
      if (this.status == 1) {
        this.status = 0
        this.$message('已撤销审核')
      } else {
        this.status = 1
        this.$message.success('已提交审核')
      }
      api.statistics.edit({ status: this.status }).then((res) => {})
    },
    handleOut() {
      this.$confirm('您确定要导出当前报表？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {

        })
        .catch(() => {})
    },
    handleClear(v) {
      v = null
      this.tableMode()
    },
    async tableMode() {
      // data11-data17本地保存数据
      if (localStorage.getItem('form1')) {
        this.data11 = JSON.parse(localStorage.getItem('form1'))
      }
      if (localStorage.getItem('form2')) {
        this.data12 = JSON.parse(localStorage.getItem('form2'))
      }
      if (localStorage.getItem('form3')) {
        this.data13 = JSON.parse(localStorage.getItem('form3'))
      }
      if (localStorage.getItem('form4')) {
        this.data14 = JSON.parse(localStorage.getItem('form4'))
      }
      if (localStorage.getItem('form5')) {
        this.data15 = JSON.parse(localStorage.getItem('form5'))
      }

      if (localStorage.getItem('form6')) {
        this.data16 = JSON.parse(localStorage.getItem('form6'))
      }
      if (localStorage.getItem('form7')) {
        this.data17 = JSON.parse(localStorage.getItem('form7'))
      }
      // 获得表格模板 data1-data7
      const obj = await this.statisticsInit.tableMode()
      this.data1 = obj.slice(0, 22)
      this.loading = false
      this.data2 = obj.slice(22, 130)
      this.data3 = obj.slice(130, 176)
      this.data4 = obj.slice(176, 238)
      this.data5 = obj.slice(238, 317)
      this.data6 = obj.slice(317, 344)
      this.data7 = obj.slice(344, 352)
      this.tableData()
    },
    async tableData() {
      // 获得提交的数据
      // obj用户保存后提交 通过接口获取提交数据 form1-form7
      const obj = await this.statisticsInit.tableData()
      this.form1 = obj.filter((item) => {
        return item.catagry_type == 1
      })
      this.form2 = obj.filter((item) => {
        return item.catagry_type == 2
      })
      this.form3 = obj.filter((item) => {
        return item.catagry_type == 3
      })
      this.form4 = obj.filter((item) => {
        return item.catagry_type == 4
      })
      this.form5 = obj.filter((item) => {
        return item.catagry_type == 5
      })
      this.form6 = obj.filter((item) => {
        return item.catagry_type == 6
      })
      this.form7 = obj.filter((item) => {
        return item.catagry_type == 7
      })
      // 合并用户提交的数据和表格模板
      this.d1 = this.handleHeBing(this.data1, this.form1)
      this.d2 = this.handleHeBing(this.data2, this.form2)
      this.d3 = this.handleHeBing(this.data3, this.form3)
      this.d4 = this.handleHeBing(this.data4, this.form4)
      this.d5 = this.handleHeBing(this.data5, this.form5)
      this.d6 = this.handleHeBing(this.data6, this.form6)
      this.d7 = this.handleHeBing(this.data7, this.form7)
      // console.log(this.d1, 'this.d1合并提交数据和表格模板')
      // console.log(this.data1, 'this.data1表格模板')
      // console.log(this.form1, 'this.form1提交数据')
    },
    handleHeBing(x, y) {
      const tempArr = x
      const Data = y
      tempArr.map((val) => {
        Data.map((val1) => {
          if (val.code === val1.code) {
            return Object.assign(val, val1)
          }
        })
      })
      return tempArr
    },
    changeTab(x, y) {
      if (
        this.d1 &&
        this.d2 &&
        this.d3 &&
        this.d4 &&
        this.d5 &&
        this.d6 &&
        this.d7
      ) {
        this.activeTab = x
      } else {
        this.$message.error('请先填写信息再进行跳转！')
      }
    },
    handlePrePage() {
      if (this.activeTab == 0) {
        this.$message({
          type: 'error',
          message: '当前已为第一章'
        })
      } else {
        this.activeTab -= 1
      }
    },
    handleNextPage() {
      if (this.activeTab == 6) {
        this.$message({
          type: 'error',
          message: '当前已为最后一章'
        })
      } else {
        this.activeTab += 1
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.entry {
  margin-top: 20px;
  &-header {
    display: flex;
    justify-content: space-between;
    > span {
      cursor: pointer;
      padding: 6px 20px;
      border-radius: 5px;
    }
    .btn1 {
      background-color: #fff;
      border: 1px solid #d7d4d4;
      color: #333;
    }
    .btn2 {
      background-color: #2f82ff;
      border: 1px solid #2f82ff;
      color: #fff;
    }
  }
  &-tabs {
    width: 800px !important;
    display: flex;
    flex-direction: column;
    margin-right: 18px;

    &-item {
      text-align: center;
      font-size: 14px;
      color: #333;
      line-height: 30px;
      cursor: pointer;
    }
    .activeTab {
      color: #2f82ff;
      font-weight: bold;
      border-bottom: 2px solid #2f82ff;
    }
  }
  &-content {
    margin-top: 22px;
  }
}
.entry /deep/ .tabs {
  justify-content: space-around;
  > div {
    flex: none;
  }
}
</style>
